import { render, staticRenderFns } from "./modal-how-oc-works.vue?vue&type=template&id=2220dcce"
import script from "./modal-how-oc-works.vue?vue&type=script&lang=js"
export * from "./modal-how-oc-works.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports